import React, { useEffect } from 'react'
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import {
    Home,
    AngleSmallLeft,
} from '../../../../assets'

import '../../../../assets/icons/icons.css'

const BackHomeTopNav = (props) => {

    const history = useHistory();

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const handleBack = () => {
        if (props.backTo) {
            history.push(props.backTo);
        } else if (props.onBack) {
            props.onBack();
        } else {
            history.goBack();
        }
    };

    console.log(props, 'test ini adalah props')

    return (
        <>
            <div className="topnav-container relative-position">
                <div className="topnav-left-side" onClick={handleBack}>
                    <AngleSmallLeft id="back-small-icon" />
                </div>
                <div className="topnav-center-side">
                    <img
                        src={props.image}
                        width={42}
                        height={42}
                        className='topnav-image'
                    />
                    <span className="topnav-title-text">{props.title}</span>
                </div>
            </div>
        </>
    )
}

export default BackHomeTopNav
